import AutoLinkText from './AutoLinkText';

export default AutoLinkText;
